import InfoLayout from "./InfoLayout";

function PrivacyPolicy() {
    return (
        <InfoLayout title="Privacy Policy">
    <h2>Data Collection</h2>
    <p>
        This freemium version of the <strong>Tabata Timer</strong> app does not collect any sensitive personal data. 
        We do not require your name, email, or any other identifying information.
    </p>

    <h2>Analytics and Anonymous Data</h2>
    <p>
        To improve app functionality, we use <strong>Google Analytics</strong>, which only collects anonymous usage statistics,
        such as the number of visits, workout duration, and device type. This information helps us optimize the app and enhance the user experience.
    </p>

    <h2>Data Sharing</h2>
    <p>
        We do <strong>not share</strong> your personal data with third parties because we do not collect any personal information.
    </p>

    <h2>Security</h2>
    <p>
        Although we do not collect sensitive data, we ensure server security and protect anonymous data against misuse.
    </p>

    <h2>Contact</h2>
    <p>
        If you have any questions regarding privacy, please contact us at: <strong>admin@tabataworkout.online</strong>
    </p>

    <h2>Policy Updates</h2>
    <p>
        These policies may change from time to time. We recommend checking the current version on this page regularly.
    </p>
</InfoLayout>

    );
}

export default PrivacyPolicy;
